import { DatePicker } from 'antd';
import dayjs from 'dayjs';

import { Field } from '../../../components/ui';
import { useT } from '../../../i18n';
import { KHOA_LOI_HIEU_LUC } from '../constants';
import type { LoiHieuLuc } from '../nghiep-vu/tri-thuc';

const DINH_DANG = 'DD/MM/YYYY';
const NGAY = 'YYYY-MM-DD';

/**
 * Hai ô ngày "Hiệu lực từ" và "Hiệu lực đến". Giá trị là ngày lịch `YYYY-MM-DD` (không giờ, không múi
 * giờ) — đúng hình backend nhận. Lỗi đặt cạnh ô sai: thiếu "từ" ở ô đầu, "đến" không sau "từ" ở ô sau.
 */
export function ChonHieuLuc({
  tu,
  den,
  batBuocTu,
  loi,
  loiServer,
  onDoi,
}: {
  tu: string | null;
  den: string | null;
  batBuocTu: boolean;
  /** Lỗi kiểm phía giao diện, đã lọc theo lúc nên hiện (sau khi bấm gửi). */
  loi: LoiHieuLuc | null;
  loiServer?: { tu?: string; den?: string };
  onDoi: (tu: string | null, den: string | null) => void;
}) {
  const { t } = useT();
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <Field
        label={t('triThuc.tep.fHieuLucTu')}
        required={batBuocTu}
        error={(loi === 'thieuTu' ? t(KHOA_LOI_HIEU_LUC.thieuTu) : undefined) ?? loiServer?.tu}
      >
        {(p) => (
          <DatePicker
            id={p.id}
            aria-describedby={p['aria-describedby']}
            status={p['aria-invalid'] ? 'error' : undefined}
            className="w-full"
            format={DINH_DANG}
            placeholder={t('triThuc.tep.chonNgay')}
            value={tu ? dayjs(tu) : null}
            onChange={(d) => onDoi(d ? d.format(NGAY) : null, den)}
          />
        )}
      </Field>
      <Field
        label={t('triThuc.tep.fHieuLucDen')}
        hint={t('triThuc.tep.fHieuLucDenGoiY')}
        error={(loi === 'denKhongSauTu' ? t(KHOA_LOI_HIEU_LUC.denKhongSauTu) : undefined) ?? loiServer?.den}
      >
        {(p) => (
          <DatePicker
            id={p.id}
            aria-describedby={p['aria-describedby']}
            status={p['aria-invalid'] ? 'error' : undefined}
            className="w-full"
            format={DINH_DANG}
            placeholder={t('triThuc.tep.khongThoiHan')}
            value={den ? dayjs(den) : null}
            disabledDate={(d) => Boolean(tu) && d.format(NGAY) <= tu!}
            onChange={(d) => onDoi(tu, d ? d.format(NGAY) : null)}
          />
        )}
      </Field>
    </div>
  );
}
